/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Ce } from './Ce';

const { GlobalVar } = Utils;

class DeferredReviewGrouping extends Ce {
    constructor() {
        super();
        this.baseUrl += '/deferredReviewGrouping';
    }

    findDeferredReviewGroupingList({
        verticalGroupingName,
        verticalGroupingSn,
        certCatId,
        certExamType,
        schoolOrgId,
        verticalGroupingStatus,
        verticalGroupingStatusNE,
        insertTime,
        certExamId,
        idNE,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let insertTimeBegin = null;
        let insertTimeEnd = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertTimeBegin, insertTimeEnd] = insertTime;
        }
        return super.get('/findDeferredReviewGroupingList', {
            verticalGroupingName,
            verticalGroupingSn,
            certCatId,
            certExamType,
            schoolOrgId,
            verticalGroupingStatus,
            verticalGroupingStatusNE,
            insertTimeBegin,
            insertTimeEnd,
            certExamId,
            idNE,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    findDeferredReviewGroupingListWithStat({
        verticalGroupingName,
        verticalGroupingSn,
        certCatId,
        certExamType,
        schoolOrgId,
        verticalGroupingStatus,
        insertTime,
        certExamId,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let insertTimeBegin = null;
        let insertTimeEnd = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertTimeBegin, insertTimeEnd] = insertTime;
        }
        return super.get('/findDeferredReviewGroupingListWithStat', {
            verticalGroupingName,
            verticalGroupingSn,
            certCatId,
            certExamType,
            schoolOrgId,
            verticalGroupingStatus,
            insertTimeBegin,
            insertTimeEnd,
            certExamId,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id } = {}) {
        return super.get('/getDetail', { id }).then(json => {
            const { groupQrCode } = json.data.data.deferredReviewGrouping;
            if (!groupQrCode) {
                json.data.data.deferredReviewGrouping.groupQrCode = [];
            } else {
                json.data.data.deferredReviewGrouping.groupQrCode = groupQrCode.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({ id, verticalGroupingName, verticalGroupingSn, certExamId, schoolOrgId } = {}) {
        return super.post('/save', {
            id,
            verticalGroupingName,
            verticalGroupingSn,
            certExamId,
            schoolOrgId,
        });
    }

    effective({ ids, isCheckTime } = {}) {
        return super.post('/effective', {
            ids,
            isCheckTime,
        });
    }

    complete({ ids } = {}) {
        return super.post('/complete', {
            ids,
        });
    }

    remove({ deferredReviewGroupingId, ids } = {}) {
        return super.post('/remove', {
            deferredReviewGroupingId,
            ids,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    saveSeatNumber({ deferredReviewGroupingId, deferredReviewApplyId, seatNumber }) {
        return super.post('/saveSeatNumber', {
            deferredReviewGroupingId,
            deferredReviewApplyId,
            seatNumber,
        });
    }

    updateFillFormTime({ deferredReviewGroupingId, fillFormTime }) {
        return super.post(
            '/updateFillFormTime',
            {
                deferredReviewGroupingId,
                fillFormTime,
            },
            {
                isHandleError: true,
                timeout: 0,
            },
        );
    }

    initDeferredReviewGroupingSeatNumber({ deferredReviewGroupingId }) {
        return super.post('/initDeferredReviewGroupingSeatNumber', { deferredReviewGroupingId });
    }
}

export default new DeferredReviewGrouping();
export { DeferredReviewGrouping };
